<template>
  <div class="profile rj-content">
    <v-overlay :value="loader" z-index="7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <h1>Mi perfil</h1>
    <p class="main-description">¡Hola<span
        v-if="user.info.user_data.names">, {{
        user.info.user_data.names.split(' ')[0]
      }} {{ user.info.user_data.surnames.split(' ')[0] }}</span>!
      Aquí podrás ver y actualizar la información personal que compartes con nosotros.</p>
    <v-card>
      <v-card-text>
        <v-expansion-panels
            v-model="panels"
            :multiple="true"
            :flat="true"
        >
          <v-expansion-panel>
            <div class="edit-btn" @click="editSection(0)">
              <i :class="!user.editable?'active':''"></i>
            </div>
            <v-expansion-panel-header>
              Mis datos
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-form
                  ref="userFormRef"
                  v-model="userForm"
                  lazy-validation
              >
                <label for="">Nombres</label>
                <v-text-field
                    v-model="user.info.user_data.names"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    placeholder=""
                    required
                    :disabled="user.editable"
                ></v-text-field>
                <label for="">Apellidos</label>
                <v-text-field
                    v-model="user.info.user_data.surnames"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    placeholder=""
                    required
                    :disabled="user.editable"
                ></v-text-field>
                <label for="">Documento de identidad</label>
                <v-text-field
                    v-model="user.info.user_data.document"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    type="text"
                    max="15"
                    placeholder=""
                    required
                    :disabled="user.editable"
                ></v-text-field>
                <label for="">País de residencia actual</label>
                <v-autocomplete
                    v-model="user.info.user_data.current_country"
                    :items="countries"
                    item-text="country"
                    item-value="country"
                    autocomplete="off"
                    placeholder="Selecciona un pais"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    :disabled="user.editable"
                ></v-autocomplete>
                <label for="">Estado o departamento de residencia actual</label>
                <v-autocomplete
                    v-model="user.info.user_data.current_place"
                    :items="states[0].states"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    placeholder="Selecciona un estado"
                    required
                    :disabled="user.editable || !states[0].country"
                ></v-autocomplete>
                <label for="">Celular</label>
                <br/>
                <!--Ver dial_code para guardarlo-->
                <div class="phone-dial-ctn">
                  <v-select
                      v-model="user.info.user_data.phone_dial"
                      class="phone-dial"
                      :items="phones"
                      item-value="dial_code"
                      :disabled="user.editable"
                      :rules="validationRules.required"
                      required
                  >
                    <template v-slot:item="{item}">
                      {{ item.name }}
                    </template>
                    <template v-slot:selection="{ item }">
                      <img :src="'/flags/'+item.code+'.png'" alt=""/>
                    </template>
                  </v-select>
                  <v-text-field
                      class="phone-value"
                      v-model="user.info.user_data.phone"
                      :rules="validationRules.required"
                      onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                      required
                      placeholder=""
                      :disabled="user.editable"
                  >
                  </v-text-field>
                </div>
                <label for="">
                  Correo electrónico
                  <span color="primary" v-if="!user.editable" small @click="flagModalChangeMail = true"
                        class="input-edit">
                  </span>
                </label>
                <v-text-field
                    v-model="user.info.user.email"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    type="mail"
                    placeholder=""
                    required
                    :disabled="true"
                ></v-text-field>
                <label for="">
                  Cambiar contraseña
                  <span color="primary" v-if="!user.editable" small @click="flagModalChangePassword = true"
                        class="input-edit">
                  </span>
                </label>
                <br>
                <br>
                <label for="">Fecha y hora de nacimiento</label>
                <v-datetime-picker
                    v-model="user.info.user_data.birth_date"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    dateFormat="yyyy-MM-dd"
                    timeFormat="HH:mm:ss"
                    width="340px"
                    placeholder=""
                    required
                    :disabled="user.editable">
                  <template slot="actions" slot-scope="{ parent }">
                    <v-btn text color="primary" @click="parent.okHandler">OK</v-btn>
                  </template>
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-timer</v-icon>
                  </template>
                </v-datetime-picker>
                <label for="">País de nacimiento</label>
                <v-autocomplete
                    v-model="user.info.user_data.born_country"
                    :items="countries"
                    item-text="country"
                    item-value="country"
                    placeholder="Selecciona un pais"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    :disabled="user.editable"
                ></v-autocomplete>
                <label for="">Estado o departamento de nacimiento</label>
                <v-autocomplete
                    v-model="user.info.user_data.born_place"
                    :items="statesBorn[0].states"
                    :rules="validationRules.required"
                    :name="Math.random()"
                    placeholder="Selecciona un estado"
                    required
                    :disabled="user.editable || !statesBorn[0].country"
                ></v-autocomplete>
              </v-form>
              <v-btn outlined v-if="!user.editable" class="save-btn " color="primary" @click="editSection(user)">Cancelar</v-btn>
              <v-btn color="primary" class="save-btn ml-4" v-if="!user.editable" @click="updateUserInfo">
                Guardar cambios
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <div class="edit-btn edit-birthday" @click="editSectionBirth(1)">
              <i :class="!user.editableBirth?'active':''"></i>
            </div>
            <v-expansion-panel-header>Celebración de cumpleaños</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="details">Ingresa la información respecto a la última celebración de tu cumpleaños.</p>
              <label for="">País</label>
              <v-autocomplete
                  v-model="user.info.user_data.last_birthday_country"
                  :items="countries"
                  item-text="country"
                  item-value="country"
                  placeholder="Selecciona un pais"
                  :rules="validationRules.required"
                  :disabled="user.editableBirth"
              ></v-autocomplete>
              <label for="">Estado o departamento</label>
              <v-autocomplete
                  v-model="user.info.user_data.last_birthday_place"
                  :items="statesLastBirth[0].states"
                  :rules="validationRules.required"
                  placeholder="Selecciona un estado"
                  required
                  :disabled="user.editableBirth || !statesLastBirth[0].country"
              ></v-autocomplete>
              <v-btn v-if="!user.editableBirth" outlined class="save-btn " color="primary" @click="editSectionBirth(user)">Cancelar</v-btn>
              <v-btn color="primary" class="save-btn ml-4" v-if="!user.editableBirth" @click="updateUserInfo">
                Guardar cambios
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <!--<div class="edit-btn" @click="editSection(user)">-->
            <!--<i :class="!user.editable?'active':''"></i>-->
            <!--</div>-->
            <v-expansion-panel-header>Mi(s) hijo(s)</v-expansion-panel-header>
            <v-expansion-panel-content>
              <children></children>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <!--<div class="edit-btn" @click="editSection(user)">-->
            <!--<i :class="!user.editable?'active':''"></i>-->
            <!--</div>-->
            <v-expansion-panel-header>Mi pareja</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!--<v-checkbox-->
              <!--v-model="couple"-->
              <!--label="Tengo pareja"-->
              <!--&gt;</v-checkbox>-->
              <p class="details">Ingresa la información de tu pareja. Puede ser tu esposo, esposa, conviviente,
                enamorado o enamorada
                o cualquier tipo de pareja sin importar el estatus legal.</p>
              <couple></couple>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <!--<div class="edit-btn" @click="editSection(user)">-->
            <!--<i :class="!user.editable?'active':''"></i>-->
            <!--</div>-->
            <v-expansion-panel-header>Mascotas</v-expansion-panel-header>
            <v-expansion-panel-content>
              <pet></pet>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <!--<div class="edit-btn" @click="editSection(user)">-->
            <!--<i :class="!user.editable?'active':''"></i>-->
            <!--</div>-->
            <v-expansion-panel-header>Pérdida de embarazo</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="details">Ingresa la información de las pérdidas de embarazo que tú o tu pareja hayan podido
                tener.</p>
              <miscarriage></miscarriage>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <!--<div class="edit-btn" @click="editSection(user)">-->
            <!--<i :class="!user.editable?'active':''"></i>-->
            <!--</div>-->
            <v-expansion-panel-header>Mudanza</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="details">Ingresa la información de la última mudanza que hayas hecho.</p>
              <moves></moves>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    <v-dialog v-model="flagModalChangeMail" persistent max-width="470px">
      <v-card class="dialog-appointment">
        <v-btn class="mx-2 close-btn" x-small fab dark @click="flagModalChangeMail = !flagModalChangeMail"
               color="secondary lighten-4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="text-center">
          <img
              src="../assets/logo.png"
              alt="logo"
              class="logo"
          >
        </v-card-title>
        <v-card-text>
          <h3 class="title-modal">Actualiza tu correo</h3>
          <p class="details">Si quieres actualizar la dirección de correo
            electrónico asociada a tu cuenta, hazlo aquí:</p>
          <v-form ref="formMail">
            <v-text-field
                v-model="newMail"
                :rules="validationRules.emailRules"
                class="w100"
                type="mail"
                placeholder="Ingresa tu nuevo correo"
                required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-7 text-center d-block">
          <v-btn color="secondary" class="d-inline-block" outlined @click="flagModalChangeMail = false">Cancelar
          </v-btn>
          <v-btn color="primary" class="d-inline-block" @click="confirmChangeMail">Cambiar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="flagModalChangePassword" persistent max-width="470px">
      <v-card class="dialog-appointment">
        <v-btn class="mx-2 close-btn" x-small fab dark @click="flagModalChangePassword = !flagModalChangePassword"
               color="secondary lighten-4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="text-center">
          <img
              src="../assets/logo.png"
              alt="logo"
              class="logo"
          >
        </v-card-title>
        <v-card-text>
          <h3 class="title-modal">Actualiza tu contraseña</h3>
          <p class="details">Si quieres actualizar la contraseña asociada a tu cuenta, hazlo aquí:</p>
          <v-form>
            <v-text-field
                v-model="newPassword"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="validationRules.required"
                class="w100"
                :type="show1 ? 'text' : 'password'"
                placeholder="Ingresa tu nueva contraseña"
                required
                @click:append="show1 = !show1"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-7 text-center d-block">
          <v-btn color="secondary" class="d-inline-block" outlined @click="flagModalChangePassword = false">Cancelar
          </v-btn>
          <v-btn color="primary" class="d-inline-block" @click="confirmChangePassword">Cambiar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="colorSnack" :timeout="10000">
      {{ textSnack }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            dark
            v-bind="attrs"
            @click="snackbar = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {phones} from "../assets/js/phones.js"
import {countries} from "../assets/js/countries.js"
import Children from "../components/Children"
import Couple from "../components/Couple"
import Pet from "../components/Pet"
import Miscarriage from "../components/Miscarriage"
import Moves from "../components/Moves"
import axios from 'axios'

export default {
  name: 'Profile',
  components: {Children, Couple, Pet, Miscarriage, Moves},
  data: () => ({
    panels: [0, 1, 2, 3, 4, 5, 6],
    panel: [],
    phones: phones,
    countries: countries,
    userForm: false,
    formMail: false,
    validationRules: {
      required: [
        v => !!v || 'Debe ingresar un valor para este campo',
      ],
      emailRules: [
        v => !!v || 'Debe ingresar un correo valido',
        v => /.+@.+\..+/.test(v) || 'Debe ingresar un correo valido',
      ],
    },
    user: {
      editable: true,
      editableBirth: true,
      info: {
        "user": {
          "id": "",
          "email": "",
          "user_image": "",
          "display_name": "",
          "user_type": 1
        },
        "user_data": {
          "names": "",
          "surnames": "",
          "document": "",
          "phone": "",
          "current_country": "",
          "current_place": "",
          "birth_date": "",
          "born_place": "",
          "born_country": "",
          "last_birthday_country": "",
          "last_birthday_place": ""
        }
      }
    },
    loader: false,
    birthday: {},
    required: [],
    phoneDial: {"name": "Peru", "dial_code": "+51", "code": "pe"},
    flagModalChangeMail: false,
    flagModalChangePassword: false,
    newMail: '',
    newPassword: '',
    show1: false,
    textSnack: '',
    snackbar: false,
    colorSnack: '',

  }),
  computed: {
    ...mapState('user', [
      'info',
    ]),
    states() {
      let country = countries.filter((item) => {
        return item.country == this.user.info.user_data.current_country
      })
      if (!country.length) {
        country = [{}]
      }
      return country
    },
    statesLastBirth() {
      let country = countries.filter((item) => {
        return item.country == this.user.info.user_data.last_birthday_country
      })
      if (!country.length) {
        country = [{}]
      }
      return country
    },
    statesBorn() {
      let country = countries.filter((item) => {
        return item.country == this.user.info.user_data.born_country
      })
      if (!country.length) {
        country = [{}]
      }
      return country
    },
  },
  watch: {
    'info': function () {
      this.user.info = JSON.parse(JSON.stringify(this.info))
    },
    'user.editable': function () {
      this.user.info = JSON.parse(JSON.stringify(this.info))
    }
  },
  methods: {
    ...mapActions(
        'user', [
          'fetchInfo',
          'updateInfo',
          'changeMail'
        ]
    ),
    ...mapActions(['loaderChange']),
    confirmChangeMail() {
      let _isValid = this.$refs.formMail.validate()
      if (_isValid) {
        this.flagModalChangeMail = false
        this.loaderChange(true)
        this.changeMail(this.newMail).then((data) => {
          this.user.info.user.email = data.user.email
          this.loaderChange(false)
        })
      }
    },

    async confirmChangePassword() {

      try {
        let request = {
          data: {
            'password': this.newPassword
          }
        }

        await axios.put('user/credential', request.data)

        this.colorSnack = 'success'
        this.textSnack = 'Se ha actualizado su contraseña con exito.'
        this.snackbar = true
        this.flagModalChangePassword = false
        /*await location.reload()*/

      } catch (error) {
        console.log(error)
        this.colorSnack = 'error'
        this.textSnack = 'Se produjo un error. Inténtalo de nuevo.'
        this.snackbar = true
        this.flagModalChangePassword = false
        /*await location.reload()*/
      }
    },

    editSection() {
      this.user.editable = !this.user.editable
      if (this.user.editable) {
        this.panels.pop(0)
      } else {
        this.panels.push(0)
      }
    },
    editSectionBirth() {
      this.user.editableBirth = !this.user.editableBirth
      if (this.user.editableBirth) {
        this.panels.pop(1)
      } else {
        this.panels.push(1)
      }
    },
    fetchUserData() {
      this.loader = true
      this.fetchInfo().finally(() => {
        this.loader = false
      })
    },
    updateUserInfo() {
      let valid = this.$refs.userFormRef.validate()
      if (valid) {
        this.loaderChange(true)
        this.updateInfo(this.user).finally(() => {
          this.loaderChange(false)
          this.user.editableBirth = true
          this.user.editable = true
        })
      } else  {
        const el = this.$el.querySelector(".v-messages.error--text:first-of-type")
        this.$vuetify.goTo(el, { offset: + 55 })
      }
    },
  },
  mounted() {
    this.fetchUserData()

   /* if (!localStorage.getItem('token')) {
      sessionStorage.setItem('url', window.location.href);
    }*/
  }
}
</script>
<style lang="scss" scoped>
  $breakpoints: (
      'tablet': 768px,
  );
  @mixin mobile {
    @media screen and (max-width: map-get($breakpoints, tablet)) {
      @content;
    }
  }
.profile {
  width: 100%;

  ::v-deep .v-expansion-panel {
    border-bottom: 1px solid #DEE3E6;
    margin-top: 0;

    &:last-child {
      border-bottom: 0;
    }

    > button {
      padding: 20px 8px 18px 8px;
      min-height: auto;
    }

    .v-expansion-panel-header {
      font-weight: 800;
      color: #656565;
      font-size: 20px;

      .v-expansion-panel-header__icon {
        margin-left: 8px;

        .v-icon {
          color: #B3B3B3 !important;
        }
      }
    }

    .v-expansion-panel-content__wrap {
      padding: 0 10px 16px;
    }
  }
}

.details {
  font-size: 12px;
  font-weight: 200;
}

.ctn-btn {
  font-weight: 200;
  margin-top: 20px;

  ::v-deep .v-btn {
    background-color: #2C8886;
  }

  label {
    margin-left: 12px;
    vertical-align: middle;
    font-weight: 200;
  }
}

.save-btn {
  margin: 35px 0 20px;
  text-transform: none;
  font-size: 14px;
  width: 160px;
  border-radius: 7px;
  height: 40px;
  @include mobile {
    display: block;
    margin: 4px auto;
    &.cancel {
      margin-left: auto;
    }
  }
}

::v-deep .v-input {
  width: 250px;
  .v-messages__message {
    padding-top: 3px;
  }
  &.w100 {
    width: 100%;
  }

  &.v-input--is-disabled {
    .v-input__slot::before {
      display: none;
    }

    .v-input__append-inner {
      display: none;
    }

    .v-text-field__details {
      display: none;
    }
  }

  .v-text-field__details {
    min-height: 0;

    .v-messages, .v-text-field__details {
      min-height: 0;
    }
  }

  .v-input__slot {
    margin-bottom: 0;

    .v-text-field__slot, .v-select__selections {
      input, .v-select__selection {
        color: #656565;
      }
    }
  }
}

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.phone-dial, .phone-value {
  display: inline-block;
  vertical-align: top;
}

.phone-dial {
  width: 53px;
  margin-right: 8px;

  &.v-input--is-disabled {
    width: 25px;
  }
}

.phone-value {
  width: 190px;

  ::v-deep .v-input__slot {
    height: 29px;
  }
}

::v-deep .v-picker__body {
  background: red;
  width: 90% !important;
  margin: 0 auto;

  .accent--text button, td .v-btn__content {
    color: #656565;
  }
}

.phone-dial-ctn {
  vertical-align: top;
}

.input-edit {
  position: relative;
  width: 17px;
  height: 15px;
  background-size: cover;
  display: inline-block;
  margin-left: 4px;
  cursor: pointer;
  color: #999 !important;
  filter: contrast(0.5);
  background-image: url("../assets/pencil.png");

  &:hover, &.active {
    background-image: url("../assets/pencil-active.png");
  }
}

.dialog-appointment {
  .details {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
  }
}
  .edit-birthday {
    @include mobile {
      top: 152px;
    }
  }
  .save-btn.ml-4 {
    @include mobile {
      margin-left: auto !important;
    }
  }
</style>
